webpackJsonp([162114328119038],{

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 3.5rem;\n  margin-bottom: 3.5rem;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 3.5rem;\n  margin-bottom: 3.5rem;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  text-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n  margin-bottom: 0.75rem;\n  @media ', ' {\n    font-size: 2rem;\n  }\n  @media ', ' {\n    font-size: 2.5rem;\n  }\n'], ['\n  position: relative;\n  text-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n  margin-bottom: 0.75rem;\n  @media ', ' {\n    font-size: 2rem;\n  }\n  @media ', ' {\n    font-size: 2.5rem;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  font-size: 7rem;\n  transform: translate(-50%, -50%);\n  opacity: 0.08;\n  user-select: none;\n  z-index: -1;\n'], ['\n  position: absolute;\n  font-size: 7rem;\n  transform: translate(-50%, -50%);\n  opacity: 0.08;\n  user-select: none;\n  z-index: -1;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  grid-column: -1 / 1;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n'], ['\n  grid-column: -1 / 1;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _kebabCase = __webpack_require__(100);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _media = __webpack_require__(18);
	
	var _Subline = __webpack_require__(40);
	
	var _Subline2 = _interopRequireDefault(_Subline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Post = _styledComponents2.default.article(_templateObject);
	
	var Title = _styledComponents2.default.h1(_templateObject2, _media.media.phone, _media.media.tablet);
	
	var Initiale = _styledComponents2.default.span(_templateObject3);
	
	var Excerpt = _styledComponents2.default.p(_templateObject4);
	
	var Article = function Article(_ref) {
	  var title = _ref.title,
	      date = _ref.date,
	      excerpt = _ref.excerpt,
	      slug = _ref.slug,
	      timeToRead = _ref.timeToRead,
	      category = _ref.category;
	
	  var firstChar = title.charAt(0);
	
	  return _react2.default.createElement(
	    Post,
	    null,
	    _react2.default.createElement(
	      Title,
	      null,
	      _react2.default.createElement(
	        Initiale,
	        null,
	        firstChar
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: slug },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      _Subline2.default,
	      null,
	      date,
	      ' : ',
	      timeToRead,
	      ' Min Read : In\xA0',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/categories/' + (0, _kebabCase2.default)(category) },
	        category
	      )
	    ),
	    _react2.default.createElement(
	      Excerpt,
	      null,
	      excerpt
	    )
	  );
	};
	
	exports.default = Article;
	module.exports = exports['default'];

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  text-transform: uppercase;\n  font-weight: bold;\n  text-align: center;\n  color: ', ';\n  position: relative;\n  padding-bottom: 1rem;\n  margin-bottom: 4rem;\n\n  &:after {\n    content: \'\';\n    height: 1px;\n    width: 50px;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    margin-left: -25px;\n    background: ', ';\n  }\n'], ['\n  font-size: ', ';\n  text-transform: uppercase;\n  font-weight: bold;\n  text-align: center;\n  color: ', ';\n  position: relative;\n  padding-bottom: 1rem;\n  margin-bottom: 4rem;\n\n  &:after {\n    content: \'\';\n    height: 1px;\n    width: 50px;\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    margin-left: -25px;\n    background: ', ';\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Title = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.fontSmall;
	}, function (props) {
	  return props.theme.dark;
	}, function (props) {
	  return props.theme.ultraLight;
	});
	
	var SectionTitle = function SectionTitle(props) {
	  return _react2.default.createElement(
	    Title,
	    null,
	    props.children
	  );
	};
	
	exports.default = SectionTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  color: ', ';\n  ', ';\n  ', ';\n  ', ';\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n'], ['\n  font-size: ', ';\n  color: ', ';\n  ', ';\n  ', ';\n  ', ';\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Line = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.fontSmall;
	}, function (props) {
	  return props.theme.light;
	}, function (props) {
	  return props.sectionTitle && 'margin-top: -3rem';
	}, function (props) {
	  return props.sectionTitle && 'margin-bottom: 4rem';
	}, function (props) {
	  return props.sectionTitle && 'text-align: center';
	});
	
	var Subline = function Subline(props) {
	  return _react2.default.createElement(
	    Line,
	    { sectionTitle: props.sectionTitle },
	    props.children
	  );
	};
	
	exports.default = Subline;
	module.exports = exports['default'];

/***/ }),

/***/ 297:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.postQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  grid-column: 2;\n  box-shadow: 0 4px 120px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  padding: 2rem 4rem;\n  background-color: ', ';\n  z-index: 9000;\n  margin-top: -3rem;\n  @media ', ' {\n    padding: 3rem 3rem;\n  }\n  @media ', ' {\n    padding: 2rem 1.5rem;\n  }\n'], ['\n  grid-column: 2;\n  box-shadow: 0 4px 120px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  padding: 2rem 4rem;\n  background-color: ', ';\n  z-index: 9000;\n  margin-top: -3rem;\n  @media ', ' {\n    padding: 3rem 3rem;\n  }\n  @media ', ' {\n    padding: 2rem 1.5rem;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(39);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Wrapper = __webpack_require__(41);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _Header = __webpack_require__(61);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Subline = __webpack_require__(40);
	
	var _Subline2 = _interopRequireDefault(_Subline);
	
	var _Article = __webpack_require__(110);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _SectionTitle = __webpack_require__(113);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _media = __webpack_require__(18);
	
	var _SiteConfig = __webpack_require__(17);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Content = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.bg;
	}, _media.media.tablet, _media.media.phone);
	
	var Category = function Category(props) {
	  var category = props.pathContext.category;
	  var _props$data$allMarkdo = props.data.allMarkdownRemark,
	      edges = _props$data$allMarkdo.edges,
	      totalCount = _props$data$allMarkdo.totalCount;
	
	  var subline = totalCount + ' post' + (totalCount === 1 ? '' : 's') + ' tagged with "' + category + '"';
	
	  return _react2.default.createElement(
	    _Wrapper2.default,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: category + ' | ' + _SiteConfig2.default.siteTitle }),
	    _react2.default.createElement(
	      _Header2.default,
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        _SiteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(
	      Content,
	      null,
	      _react2.default.createElement(
	        _SectionTitle2.default,
	        null,
	        'Category \u2013 ',
	        category
	      ),
	      _react2.default.createElement(
	        _Subline2.default,
	        { sectionTitle: true },
	        subline,
	        ' (See ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/categories' },
	          'all categories'
	        ),
	        ')'
	      ),
	      edges.map(function (post) {
	        return _react2.default.createElement(_Article2.default, {
	          title: post.node.frontmatter.title,
	          date: post.node.frontmatter.date,
	          excerpt: post.node.excerpt,
	          timeToRead: post.node.timeToRead,
	          slug: post.node.fields.slug,
	          category: post.node.frontmatter.category,
	          key: post.node.fields.slug
	        });
	      })
	    )
	  );
	};
	
	exports.default = Category;
	
	/* eslint no-undef: off */
	
	var postQuery = exports.postQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-category-js-161ae21447f160854cec.js